// This file was autogenerated from running npm run sync-files.
// DO NOT EDIT THIS FILE DIRECTLY.
// Edit the source file below and then run `npm run sync-files`
// Source: ui/oopsyraidsy/data/04-sb/trial/tsukuyomi-ex.ts

import NetRegexes from '../../../../../resources/netregexes';
import ZoneId from '../../../../../resources/zone_id';
import { OopsyData } from '../../../../../types/data';
import { OopsyTriggerSet } from '../../../../../types/oopsy';

// TODO: Taking multiple role-based Steel of the Underworld (B133) hits.

export type Data = OopsyData;

// Tsukuyomi Unreal
const triggerSet: OopsyTriggerSet<Data> = {
  zoneId: ZoneId.TsukuyomisPainUnreal,
  damageWarn: {
    'TsukuyomiUn Moonlight Lunar Halo': 'B14A', // donut from orbs in final phase
    'TsukuyomiUn Moonfall': 'B145', // meteor drop big circles
    'TsukuyomiUn Moondust Crater': 'B160', // meteor explosions later
    'TsukuyomiUn Dancing Fan Tsukui-No-Maiogi': 'B13A', // fan circle aoe
    'TsukuyomiUn Waxing Grudge': 'B152', // melee range circle from Full Moon buff
    'TsukuyomiUn Waning Grudge': 'B153', // donut from New Moon Buff
    'TsukuyomiUn Dark Blade': 'B14E', // right-side cleave
    'TsukuyomiUn Bright Blade': 'B14F', // left side cleave
  },
  shareFail: {
    'TsukuyomiUn Torment Unto Death': 'B12F', // tank buster conal cleave
  },
  soloWarn: {
    'TsukuyomiUn Lead Of The Underworld': 'B132', // "Beg for Mercy!" stack
    'TsukuyomiUn Lunacy': 'B151', // 4x stack marker
  },
  triggers: [
    {
      id: 'TsukuyomiUn Moonlit',
      type: 'GainsEffect',
      // Five stacks of Moonlit or Moonshadowed is instant death.
      netRegex: NetRegexes.gainsEffect({ effectId: '602', count: '05' }),
      mistake: (_data, matches) => {
        return {
          type: 'fail',
          name: matches.target,
          reportId: matches.targetId,
          text: matches.effect,
        };
      },
    },
    {
      id: 'TsukuyomiUn Moonshadowed',
      type: 'GainsEffect',
      // Five stacks of Moonlit or Moonshadowed is instant death.
      netRegex: NetRegexes.gainsEffect({ effectId: '603', count: '05' }),
      mistake: (_data, matches) => {
        return {
          type: 'fail',
          name: matches.target,
          reportId: matches.targetId,
          text: matches.effect,
        };
      },
    },
  ],
};

export default triggerSet;
